export default class MyWorkProto {

    constructor() {

        // this is just an interface

        // this.fromUserId             = null
        // this.myWorkId               = 'redefine-me'
        //
        // this.dateCreated            = null  // whem my work created (ar since ar, assigned since assigned)

        // this.startDate              = null
        // this.endDate                = null

        // this.startMoment            = null
        // this.endMoment              = null

        // this.canMoveToInbox         = false
        // this.canMoveToSomeday       = false
        // this.canChangeDate          = false
        // this.isNew                  = false
    }

    // Interface methods
    get title():string|null {return null}

    get isNew() { return false }
    get isPastdue() { return false }

    get canMoveToInbox() { return false }
    get canMoveToSomeday() { return false }
    get canChangeDate() { return false }
    get canChangePriority() { return false }

    get fromUserId(): ID | null { return null }
    get myWorkId():RID|null { return null }
    get dateCreated():Moment | null { return moment() }   // whem my work created (ar since ar, assigned since assigned)

    get isDateRange() {return false}

    get startDate():Moment|undefined|null { return null }
    get endDate():Moment|undefined|null { return null }

    get startMoment():Moment|undefined|null { return undefined }   // when we have time
    get endMoment():Moment|undefined|null { return undefined }     // not sure if needed

    get priority() {return 5}           // normal priority

    get myWorkStartDate() {return this.startDate}
    get myWorkEndDate() {return this.endDate}
    get myWorkDateCreated() {return this.dateCreated}
    get myWorkCanMoveToInbox() {return this.canMoveToInbox}
    get myWorkCanMoveToSomeday() {return this.canMoveToSomeday}
    get myWorkCanChangeDate() {return this.canChangeDate}



}
